var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.79816,6.31767a.62633.62633,0,0,0-.92191,0l-7.87613,7.94717L4.12424,6.31792a.62633.62633,0,0,0-.92191,0L2.20047,7.32884a.63983.63983,0,0,0,0,.93026l9.3387,9.42348a.62657.62657,0,0,0,.92166,0L21.8,8.2591a.6412.6412,0,0,0,0-.93051Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.878ee7f62caec00165e97c9185482217.svg";
export { ForwardRef as ReactComponent };